<template>
  <HistoryTabTemplate
    :items="items"
    :loading="loading">
    <QuestionCard
      v-for="(item, itemIndex) in items"
      :key="`question-${itemIndex}`"
      :data-qa="`question-${itemIndex}`"
      :item="item"
      @openChat="val => $emit('openChat', val)"/>
  </HistoryTabTemplate>
</template>
<script>
import QuestionCard from 'components/common/blocks/questions/QuestionCard.vue'
import HistoryTabTemplate from 'components/tenders/tender page/HistoryTabTemplate.vue'
/**
 * Вопросы к участникам в панели истории
 */
export default {
  name: 'questionsHistory',
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
  },
  components: {
    QuestionCard,
    HistoryTabTemplate
  }
}
</script>
